require('./componentPalette.i18n.json');
require('./componentPalette.tpl.html');
require('./componentPaletteController.js');
require('./uiDraggableComponentButton.js');

const ComponentPaletteComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentPalette/componentPalette.tpl.html',
    controller: 'componentPaletteController',
    bindings: {
        formTemplateType: '<'
    }
};

angular.module('ums.configuration')
    .component('uiComponentPalette', ComponentPaletteComponent);
